<template>
  <div class="success_wrap">
    <div class="img">
      <img src="@/assets/icons/成功.png"
           alt="">
    </div>

    <div>正在为你创建试卷答题卡，请耐心等待... </div>
  </div>
</template>

<script>
import { getTeacherList } from '@/api/choiceness.js'

export default {
  data () {
    return {
    }
  },
  mounted () {
    let params = {
      edu_paper_id: this.$route.query.edu_paper_id,
      is_kujc:1
    }
     if(this.$route.query&&this.$route.query.is_order_paper !== 'undefined' ){
    params.is_order_paper = this.$route.query.is_order_paper   
  } 
    this.doTeacherPaper(params)

  },
  methods: {
    async doTeacherPaper (params) {
  try {
      const { data } = await getTeacherList(params) 
      let token = JSON.parse(window.localStorage.getItem('userInfo')).token
      console.log(data)
      if (data.list) {
        this.$router.push('/code?id=' + data.list.user_paper_id +'&is_order_paper='+this.$route.query.is_order_paper + '&token=' + token)
      } 
     
 
} catch (err) {
  window.localStorage.removeItem('userInfo')
  this.$router.go(-1)
}

    }

  }
}
</script>

<style scoped lang="scss">
.success_wrap {
  margin: 8vh auto;
  text-align: center;
  font-weight: 500;
  color: #333333;
  line-height: 23px;
  font-size: 20px;
  .img {
    width: 72px;
    height: 72px;
    // padding: 6px;
    margin: 2vh auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
}

@media screen and (min-width: 710px) {
  .success_wrap {
    margin-top: 9vh;
  }
}
@media screen and (min-width: 1000px) {
  .success_wrap {
    margin-top: 12vh;
  }
}
</style>